<template>
    <re-b-modal ref="material_bom" header="BOM"
                hide-footer superLarge fit-content
                @hide="bomTreeLoad=false">
        <bom-tree ref="bomTree" v-if="bomTreeLoad"
                  :material="material?material:localMaterial"
                  :parent-material="parentMaterial"
                  class="h-100"
                  @noBom="$refs.material_bom.hide()"></bom-tree>
    </re-b-modal>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import BomTree from "@/components/bom/BomTree.vue";

export default {
    name: "BomTreeModal",
    components: {BomTree, ReBModal},
    props: {
        material: String
    },
    data() {
        return {
            bomTreeLoad: true,
            localMaterial: null,
            parentMaterial: null
        }
    },
    methods: {
        showModal(parentMaterial = null) {
            this.$refs.material_bom.showModal();
            if (parentMaterial) {
                this.parentMaterial = parentMaterial;
            }
            this.$nextTick(() => this.bomTreeLoad = true);
        },
        showModalV2(material = null, parentMaterial = null) {
            if (!material) {
                this.$message.warning('无效的物料号');
                return;
            }
            this.localMaterial = material;
            this.showModal(parentMaterial);
        },
    }
}
</script>


<style scoped>

</style>
